<template>
    <div>
        <div
            ref="isoregionTooltip"
            class="margin-bottom-10">
            <slot name="isoregion"></slot>
        </div>
        <div ref="isocountryTooltip">
            <div class="margin-bottom-10">
                <h3 class="entity__headline">
                    <label
                        for="isocountries"
                        class="required">{{ trans('COMPANY_INSIGHTS_HEADQUARTER') }}</label>
                </h3>
                <select-searchable
                    id="isocountries"
                    :options="countries"
                    :disabled="allFiltersDisabled"
                    option-id-prefix="isocountry_"
                    name="isocountries[]"
                    :search-placeholder="trans('FORM_COUNTRY_SEARCH')"
                    :search-name="ISO_SEARCH_FIELD_ID"
                    :search-id="ISO_SEARCH_FIELD_ID"
                    @select="setSelectedCountry" />
            </div>
        </div>
    </div>
</template>

<script>
    import SelectSearchable from 'components/selectSearchable';
    import Translator from 'tools/trans';

    const ISO_SEARCH_FIELD_ID = 'isocountrySearch';

    export default {
        components: {
            'select-searchable': SelectSearchable,
        },
        model: {
            prop: 'checked',
            event: 'change',
        },
        props: {
            selectId: { type: String, required: true },
            disabled: { type: Boolean, default: false },
            blocked: { type: Boolean, default: false },
            locale: { type: String, default: 'en' },
        },
        data() {
            return {
                isoregions: {},
                isocountryElement: null,
                countries: [],
                selectedCountries: [],
                selectedCountriesIDs: [],
                ISO_SEARCH_FIELD_ID: ISO_SEARCH_FIELD_ID,
            };
        },
        computed: {
            allFiltersDisabled() {
                return this.$store.state.allFiltersDisabled;
            },
        },
        watch: {
            disabled(value) {
                this.setDisabled(value);
            },
        },
        methods: {
            trans: Translator.trans,
            setSelectedCountry(selectedCountries) {
                this.selectedCountries = selectedCountries;
                this.selectedCountriesIDs = [];
                for (let i = 0, len = this.selectedCountries.length; i < len; i++) {
                    if (this.selectedCountries[i].checked === true) {
                        this.selectedCountriesIDs.push(parseInt(this.selectedCountries[i].value));
                    }
                }
            },
            initData() {
                for (let i = 0; i < this.isocountryElement.options.length; i++) {
                    const countryIsoCode = this.isocountryElement.options[i].value;
                    const countryName = this.isoregions[countryIsoCode];
                    if (countryIsoCode.length > 0) {
                        this.countries.push({
                            name: countryName,
                            value: countryIsoCode,
                            checked: this.isocountryElement.options[i].selected,

                        });
                        if (this.isocountryElement.options[i].selected) {
                            this.selectedCountriesIDs.push(countryIsoCode);
                        }
                    }
                }

                this.initTooltip();
            },
            initTooltip() {
                if (this.blocked) {
                    this.$refs.isoregionTooltip.dataset.tooltip = '';
                    this.$refs.isoregionTooltip.dataset.tooltipSettings="{'target':'.entityTooltip','openOnClick':true,'width':350,'hideArrow':false,'position':'right','showOverlay':true}";
                    this.$refs.isocountryTooltip.dataset.tooltip = '';
                    this.$refs.isocountryTooltip.dataset.tooltipSettings="{'target':'.entityTooltip','openOnClick':true,'width':350,'hideArrow':false,'position':'right','showOverlay':true}";
                }
            },
            bindResetEvent() {
                document.querySelector('[data-entityfilter]').addEventListener('reset', () => {
                    this.clearCheckboxes();
                    this.clearSearch();
                });
            },
            clearCheckboxes() {
                this.countries.forEach(country => country.checked = false);
            },
            clearSearch() {
                document.getElementById(ISO_SEARCH_FIELD_ID).value = '';
            },
        },
        created() {
            this.isocountryElement = document.getElementById(this.selectId);
            this.isoregions = JSON.parse(this.isocountryElement.dataset.countries);
        },
        mounted() {
            this.initData();
            this.bindResetEvent();
        },
    };

</script>
